import { GetQuestionariesModule } from '@app/shared/models/elevate-data-models';
import { AppConsts } from '@shared/AppConsts';

export const getCustomQuoteQuestions = (): Array<GetQuestionariesModule.IQuestion> => {
    return [
        {
            AllowMultiAnswers: false,
            Answer: [
                {
                    AnswerSequence: 1,
                    AnswerType: 'SingleEntryAnswerProvider',
                    ApplicantAttributeName: 'Net monthly income',
                    AutoComplete: false,
                    DataType: 'Number',
                    OutComes: [],
                    OverrideAnswer: false,
                    Prompt: '',
                    Text: 'Net monthly income',
                    Value: null,
                    id: 54915
                }
            ],
            AnswerRequired: true,
            ExternalReferenceId: AppConsts.QuirckExtQuestionId.CustomNetIncome,
            Id: null,
            IsVisibleAtStart: true,
            Prompt: 'This is your average monthly income over the past 12 months that you earn from your noted Current Main Occupation and includes guaranteed salary, non-guaranteed salary plus any share of profits from your employer such as dividends (but excludes all passive income such as investment income and rent) less the deduction of any PAYE or other income taxes.',
            QuestionSequence: null,
            Text: 'Net monthly income (after tax and other deductions)',
            Title: 'Custom net income',
            QuestionType: 2,
            ValueGiven: undefined,
            overrideVisibility: false
        }
    ];
};

export const getCustomExistingCoverQuestions = (): Array<GetQuestionariesModule.IQuestion> => {
    return [
        {
            AllowMultiAnswers: false,
            Answer: [
                {
                    AnswerSequence: 1,
                    AnswerType: 'BasicAnswerProvider',
                    ApplicantAttributeName: null,
                    AutoComplete: false,
                    DataType: 'String',
                    OutComes: [],
                    OverrideAnswer: false,
                    Prompt: '',
                    Text: 'No',
                    Value: '0',
                    id: 76979
                },
                {
                    AnswerSequence: 2,
                    AnswerType: 'BasicAnswerProvider',
                    ApplicantAttributeName: null,
                    AutoComplete: false,
                    DataType: 'String',
                    OutComes: [
                        {
                            AnswerId: 76977,
                            QuestionProfileId: 20333,
                            SectionId: 1590,
                            SectionVisibilityQuestionProfiles: null,
                            Visibility: 'ShowQuestionImmediately',
                            id: 17152
                        }
                    ],
                    OverrideAnswer: false,
                    Prompt: '',
                    Text: 'Yes',
                    Value: '1',
                    id: 76977
                }
            ],
            AnswerRequired: true,
            ExternalReferenceId: AppConsts.QuirckFinancialExtQuestionId.Custom_Existing_cover,
            Id: 20330,
            IsVisibleAtStart: true,
            Prompt: '',
            QuestionSequence: 6,
            Text: 'Do you have existing risk cover policies, including any personal or business assurance cover where you are the life insured, as well as any Group cover through your employer?',
            Title: 'Your existing cover',
            QuestionType: 1,
            ValueGiven: undefined,
            overrideVisibility: false
        }

    ];
};

export const getCoverReasonQuestions = (): Array<GetQuestionariesModule.IQuestion> => {
    return [
        {
            AllowMultiAnswers: false,
            Answer: [
                {
                    AnswerSequence: 1,
                    AnswerType: 'BasicAnswerProvider',
                    ApplicantAttributeName: null,
                    AutoComplete: false,
                    DataType: 'String',
                    OutComes: [],
                    OverrideAnswer: false,
                    Prompt: '',
                    Text: 'Yes, they are the same',
                    Value: 'Yes',
                    id: null
                },
                {
                    AnswerSequence: 2,
                    AnswerType: 'BasicAnswerProvider',
                    ApplicantAttributeName: null,
                    AutoComplete: false,
                    DataType: 'String',
                    OutComes: [],
                    OverrideAnswer: false,
                    Prompt: '',
                    Text: 'No, they are different',
                    Value: 'No',
                    id: null
                }
            ],
            AnswerRequired: true,
            ExternalReferenceId: AppConsts.QuirckExtQuestionId.PolicyHolderIsInsuredLife,
            Id: null,
            IsVisibleAtStart: true,
            Prompt: '',
            QuestionSequence: 0,
            Text: 'Please confirm that the Policyholder is intended to be the the same as the Life Insured on this application',
            Title: 'Policyholder',
            QuestionType: 1,
            ValueGiven: undefined,
            overrideVisibility: false
        },
        {
            AllowMultiAnswers: false,
            Answer: [
                {
                    AnswerSequence: 1,
                    AnswerType: 'BasicAnswerProvider',
                    ApplicantAttributeName: null,
                    AutoComplete: false,
                    DataType: 'String',
                    OutComes: [],
                    OverrideAnswer: false,
                    Prompt: '',
                    Text: 'Personal cover',
                    Value: 'Personal cover',
                    id: null
                },
                {
                    AnswerSequence: 2,
                    AnswerType: 'BasicAnswerProvider',
                    ApplicantAttributeName: null,
                    AutoComplete: false,
                    DataType: 'String',
                    OutComes: [],
                    OverrideAnswer: false,
                    Prompt: '',
                    Text: 'Business assurance',
                    Value: 'Business assurance',
                    id: null
                }
            ],
            AnswerRequired: true,
            ExternalReferenceId: AppConsts.QuirckExtQuestionId.CoverReason,
            Id: null,
            IsVisibleAtStart: true,
            Prompt: '',
            QuestionSequence: 1,
            Text: 'What is the reason for the cover being applied for?',
            Title: 'Reason for cover',
            QuestionType: 1,
            ValueGiven: undefined,
            overrideVisibility: false
        },
        {
            AllowMultiAnswers: true,
            Answer: [
                {
                    AnswerSequence: 1,
                    AnswerType: 'BasicAnswerProvider',
                    ApplicantAttributeName: null,
                    AutoComplete: false,
                    DataType: 'String',
                    OutComes: [],
                    OverrideAnswer: false,
                    Prompt: '',
                    Text: 'Key Man Cover',
                    Value: 'Key Man Cover',
                    id: null
                },
                {
                    AnswerSequence: 2,
                    AnswerType: 'BasicAnswerProvider',
                    ApplicantAttributeName: null,
                    AutoComplete: false,
                    DataType: 'String',
                    OutComes: [],
                    OverrideAnswer: false,
                    Prompt: '',
                    Text: 'Buy and Sell Cover',
                    Value: 'Buy and Sell Cover',
                    id: null
                },
                {
                    AnswerSequence: 3,
                    AnswerType: 'BasicAnswerProvider',
                    ApplicantAttributeName: null,
                    AutoComplete: false,
                    DataType: 'String',
                    OutComes: [],
                    OverrideAnswer: false,
                    Prompt: '',
                    Text: 'Contingent Liability Cover',
                    Value: 'Contingent Liability Cover',
                    id: null
                }
            ],
            AnswerRequired: true,
            ExternalReferenceId: AppConsts.QuirckExtQuestionId.BusinessAssuranceType,
            Id: null,
            IsVisibleAtStart: false,
            Prompt: '',
            QuestionSequence: 2,
            Text: 'What Business Assurance are you looking for?',
            Title: 'Reason for cover',
            QuestionType: 0,
            ValueGiven: undefined,
            overrideVisibility: true
        }
    ];
};

export const quickQuoteQuestionReferenceIds = (): string[]  => [
    'age',
    'gender',
    'DND_sex',
    'smoker_status',
    'marital_status',
    'Occupation',
    'monthly_income',
    'passive_income',
    'education',
    'Residency',
    'DND_sales_channel',
    'DND_Show_products',
    'DND_SA_ID_number',
];
